import { LinkPreview } from './link';

export * from './link';

export function effects() {
  customElements.define('hive-link-preview', LinkPreview);
}
